<template>
    <div class="ai-prompts-editor p-4">
        <div class="mb-4">
            <label class="block text-sm font-medium mb-1">
                {{ t('widget.aiInstructions.customize.systemPrompt') }}
            </label>
            <VcMdEditor
                :model-value="systemPrompt"
                :min-height="180"
                @update:model-value="$emit('change-system-prompt', $event)"
            />
        </div>

        <div>
            <label class="block text-sm font-medium mb-1">
                {{ t('widget.aiInstructions.customize.userPrompt') }}
            </label>
            <VcMdEditor
                :model-value="userPrompt"
                :min-height="180"
                @update:model-value="$emit('change-user-prompt', $event)"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { VcMdEditor } from '@voicenter-team/voicenter-ui-plus'

const { t } = useI18n()

defineProps<{
    systemPrompt: string
    userPrompt: string
}>()

defineEmits<{
    (e: 'change-system-prompt', value: string): void
    (e: 'change-user-prompt', value: string): void
}>()
</script>
